<template>
    <b-popover
        id="treatmentCalendarPopOver"
        ref="treatmentCalendarPopOver"
        :target="target"
        placement="bottomleft"
        triggers="click blur"
        custom-class="treatment-calendar"
        class="pl-0 pr-0"
    >
        <template #title
            ><div class="d-flex justify-content-between align-items-center">
                <span class="text-title">Select Date </span>
                <button
                    type="button"
                    class="btn btn-sm"
                    v-b-tooltip.hover.top
                    title="Jump to today's date"
                    @click="$emit('set-to-current-time')"
                >
                    <i class="fas fa-history pr-1"></i>Today
                </button>
            </div></template
        >
        <date-picker
            name="date"
            :config="datePickerOptions"
            v-model="selectedDate"
            @dp-change="setActiveDate"
        ></date-picker>
    </b-popover>
</template>
<script>
export default {
    props: {
        target: {
            type: String
        }
    },
    data() {
        return {
            selectedDate: null,
            datePickerOptions: {
                useCurrent: true,
                format: "DD/MM/YYYY",
                inline: true
            }
        };
    },
    async mounted() {
        this.datePickerOptions.format = this.getDateFormat();
        this.selectedDate = this._now().toFormat(this._dateFormat);
    },

    methods: {
        setActiveDate() {
            this.$emit("refresh", this.selectedDate);
        }
    }
};
</script>
<style scoped>
.treatment-calendar {
    width: 300px;
    max-width: 300px;
}

.text-title {
    font-size: 14px;
}
</style>
